<div class="comic-bubble">
    <div class="comic-text">
        {{ review.content }}
    </div>
    <div>
        <input type="text" [(ngModel)]="review.response" placeholder="Escribe tu respuesta" />
        <button (click)="responderRevision()">Enviar</button>
    </div>
</div>